import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
export enum OCRState {
  READY_TO_RUN = 'READY_TO_RUN',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
registerEnum({ enum: OCRState, name: 'OCRState' });
@Entity()
export class OCRProgress extends AdornisEntity {
  static override _class = 'OCRProgress';
  constructor(doc: Omit<EntityData<OCRProgress>, '_class'> & { _class?: string }) {
    super(doc);
  }
  @Field(() => OCRState)
  status?: Maybe<OCRState>;
  @Field(() => String)
  answer?: Maybe<string>;

  @Field(() => Float)
  cost?: Maybe<number>;
}
